<template>
  <div class="my-radio" @click="onClick()">
    <vs-radio v-model="bindData" :vs-value="vsValue" :vs-name="vsName" :disabled="disabled">
      <slot></slot>
    </vs-radio>
  </div>
</template>

<script>
export default {
  mounted() {
    this.bindData = this.value
  },
  props: ['value', 'vsName', 'vsValue', 'disabled'],
  data() {
    return {
      bindData: null,
      times: 0
    }
  },
  watch: {
    value(val) {
      this.bindData = val
    }, 
    disabled(val) { 
      this.disabled = val
    }
  },
  methods: {
    onClick() {
      if(this.times === 0 && !this.disabled) {
        const valueInput = this.bindData === this.vsValue ? null : this.vsValue
        this.$emit('input', valueInput)
        this.$emit('change')
        this.times++
        setTimeout(() => { 
          this.times = 0
          this.bindData = valueInput
        }, 10)
      }
    }
  }
}
</script>


<style scoped>
.my-radio {
  display: inline-flex;
  align-items: center;
}
</style>
